import React, {CSSProperties} from 'react'
import {style} from '../../util/style'

const styles = style('line')

const LineStyle: CSSProperties = {
	background: '#ebebeb',
	border: 'none',
	height: '1px',
	width: '100%'
}

export const Line = () => <hr className={styles()} style={LineStyle} />
